<div class="jumbotron-fluid pt-2 pt-md-3 pt-lg-4 pt-xl-2 mb-0 pb-4 mx-auto px-lg-0 col-12">
  <div class="global-container container">
    <div class="row mx-auto mx-md-4 mx-xl-0 px-xl-0">
      <div class="thunder-col-1 col-12 col-md-6 col-xl-3 mb-3 mx-md-auto mx-xl-1 px-0">
        <div class="sm-card-1 card shadow mx-0 py-0">
          <div class="card-body my-0 py-2 py-xl-3">
            <div class="row">
              <div class="col mx-0 px-0 mx-lg-1">
                <div class="text-uppercase text-gray font-weight-bold mb-1">
                  <span class="sm-card-title-2">total regions</span>
                </div>
                <div class="row">
                  <div class="col-auto">
                    <div class="text-primary font-weight-bold h5 mb-0 pb-0">
                      <span class="pl-3 pb-0">{{ totals[0].areas }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto align-self-baseline">
                <i class="fas fa-map-marker text-secondary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="thunder-col-2 col-12 col-md-6 col-xl-2 mb-3 mx-md-auto mx-xl-1 px-0">
        <div class="sm-card-2 card shadow mx-0 py-0">
          <div class="card-body my-0 py-2 py-xl-3">
            <div class="row">
              <div class="col mx-0 px-0 mx-lg-1">
                <div class="text-uppercase text-gray font-weight-bold mb-1">
                  <span class="sm-card-title-2">total towns</span>
                </div>
                <div class="row">
                  <div class="col-auto">
                    <div class="text-primary font-weight-bold h5 mb-0 pb-0">
                      <span class="pl-3 pb-0">{{ totals[0].towns }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto align-self-baseline">
                <i class="fas fa-map-marker-alt text-secondary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="thunder-col-3 col-12 col-md-6 col-xl-3 mb-3 mx-md-auto mx-xl-1 px-0">
        <div class="sm-card-3 card shadow mx-0 py-0">
          <div class="card-body my-0 py-2 py-xl-3">
            <div class="row">
              <div class="col mx-0 px-0 mx-lg-1">
                <div class="text-uppercase text-gray font-weight-bold mb-1">
                  <span class="sm-card-title-3">total Stations</span>
                </div>
                <div class="row">
                  <div class="col-auto">
                    <div class="text-primary font-weight-bold h5 mb-0 pb-0">
                      <span class="pl-3 pb-0">{{ totals[0].stations }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto align-self-baseline">
                <i class="fas fa-gas-pump text-secondary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="thunder-col-4 col-12 col-md-6 col-xl-2 mb-3 mx-md-auto mx-xl-0 px-0">
        <div class="sm-card-4 card shadow mx-0 py-0">
          <div class="card-body my-0 py-2 py-xl-3">
            <div class="row">
              <div class="col mx-0 px-0 mx-lg-1">
                <div class="text-uppercase text-gray font-weight-bold mb-1">
                  <span class="sm-card-title-4">revenue</span>
                </div>
                <div class="row">
                  <div class="col-auto">
                    <div class="text-primary font-weight-bold h5 mb-0 pb-0">
                      <span class="pl-3 pb-0">{{
                        totals[0].revenue | number
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto align-self-baseline">
                <i class="fas fa-dollar-sign text-secondary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="thunder-col-5 col-12 col-md-6 col-xl-2 mb-2 mb-xl-3 mx-md-auto mx-xl-1 px-0"
      >
        <div class="sm-card-5 card shadow py-0">
          <div class="card-body my-0 py-2 py-xl-3">
            <div class="row">
              <div class="col mx-0 px-0 mx-lg-2">
                <div class="text-uppercase text-gray font-weight-bold mb-1">
                  <span class="sm-card-title-5">sms left</span>
                </div>
                <div class="row">
                  <div class="col-auto">
                    <div class="text-primary font-weight-bold h5 mb-0 pb-0">
                      <span class="pl-3 pb-0">{{ numberOfSms }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto align-self-baseline">
                <i class="fas fa-sms text-secondary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="components row mt-0 mt-xl-2 py-0 py-xl-1 mb-2">
      <div class="col-xs-12 col-md-12 col-xl-6">
        <div class="container mt-0 mb-2 mx-0 shadow-lg">
          <div class="row">
            <div class="col-12">
              <h3 class="rub-head4 text-info text-center font-weight-bold pt-0 py-1">
                Notifications
              </h3>
            </div>
          </div>
        </div>
        <div class="big-card-1 card shadow-lg px-1 mb-3 pb-0">
          <div class="big-card-body-1 card-body pt-xl-2 mx-0 px-0 px-xl-1 mb-0 pb-0">
            <tabset>
              <tab heading="Creation Approvals">
                <div class="big-card-1b card shadow-lg mt-2 mb-0">
                  <div class="big-card-body-1b card-body mt-xl-2 pt-xl-1 pb-xl-0 px-auto">
                    <div class="item-header mb-1">
                      <div class="row">
                        <div class="col-7">
                          <h5 class="text-center text-info">Type</h5>
                        </div>
                        <div class="col-4">
                          <h5 class="text-center text-info mr-2">Total</h5>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto" routerLink="/approve">
                            <!--div class="col-4 mx-0 px-0 mx-lg-auto">
                              <span class="itemCreated">1 &nbsp; TC20332</span>
                            </div-->
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1">Regional Creations</span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated-a ml-5">{{
                                creationApprovals.regionalCreations
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto" routerLink="/approve">
                            <!--div class="col-4 mx-0 px-0 mx-lg-auto">
                              <span class="itemCreated">1 &nbsp; TC20332</span>
                            </div-->
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1">Station Creations</span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated-a ml-5">{{
                                creationApprovals.stationCreations
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto" routerLink="/approve">
                            <!--div class="col-4 mx-0 px-0 mx-lg-auto">
                              <span class="itemCreated">1 &nbsp; TC20332</span>
                            </div-->
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1">
                                Town Creations
                              </span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated-a ml-5">{{
                                creationApprovals.townCreations
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </tab>
              <tab heading="Transaction Approvals">
                <div class="big-card-1b card shadow-lg mt-2 mb-0">
                  <div class="big-card-body-1b card-body mt-xl-2 pt-xl-1 pb-3 px-auto">
                    <div class="item-header mb-1">
                      <div class="row">
                        <div class="text-center col-7">
                          <h5 class="text-info">Type</h5>
                        </div>
                        <div class="col-4">
                          <h5 class="text-center text-info mr-2">Total</h5>
                        </div>
                      </div>
                    </div>
                    <div class="item-container mt-1 mb-0 py-0">
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto"
                            routerLink="/transactions/approve/loanaccrualdays">
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1">
                                Accrual Days</span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="rate-selected ml-5">
                                {{ transactionApprovals.accrualDaysApprovals }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="list-card card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto"
                            routerLink="/transactions/approve/loanamortizecycle">
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1">
                                Amortization Cycle</span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="rate-selected ml-5">
                                {{
                                transactionApprovals.amortizationCycleApprovals
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto"
                            routerLink="/transactions/approve/loanamortizetype">
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1">
                                Amortization Type</span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="rate-selected ml-5">
                                {{
                                transactionApprovals.amortizationTypeApprovals
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto"
                            routerLink="/transactions/approve/interestrate">
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1">
                                Loan Interest</span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="rate-selected ml-5">
                                {{ transactionApprovals.loanInterestApprovals }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto" routerLink="/transactions/approve/loanlimit">
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1"> Loan Limit</span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="rate-selected ml-5">
                                {{ transactionApprovals.loanLimitApprovals }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto" routerLink="/transactions/approve/loantenure">
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1"> Loan Tenure</span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="rate-selected ml-5">
                                {{ transactionApprovals.loanTenureApprovals }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto"
                            routerLink="/transactions/approve/reverseinterest">
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1">
                                Reversed Interest</span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="rate-selected ml-5">
                                {{
                                transactionApprovals.reversedInterestApprovals
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto"
                            routerLink="/transactions/approve/waiveinterest">
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1">
                                Waived Interest</span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="rate-selected ml-5">
                                {{
                                transactionApprovals.wavedInterestApprovals
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                        <div class="card-body mt-0 pt-0 mb-0 pb-0 mx-0 mx-md-auto">
                          <div class="row mt-0 pt-0 mb-0 pb-0 mx-md-auto"
                            routerLink="/transactions/approve/reverseprincipal">
                            <div class="col-6 mx-0 pr-0 pl-1 text-center">
                              <span class="itemCreated ml-1">
                                Waived Principal</span>
                            </div>
                            <div class="col-4 mx-0 pr-0 pl-1 text-center">
                              <span class="rate-selected ml-5">
                                {{
                                transactionApprovals.wavedPrincipalApprovals
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </tab>
            </tabset>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-12 col-xl-6">
        <div class="container mt-3 mt-md-2 mt-lg-3 mt-xl-0 mb-2 mx-0 shadow-lg">
          <div class="row">
            <div class="col-12">
              <h3 class="rub-head4 text-info text-center font-weight-bold pt-0 py-1">
                Analysis
              </h3>
            </div>
          </div>
        </div>
        <div class="big-card-2 card shadow-lg mb-3 pb-0">
          <div class="big-card-body-2 card-body px-auto px-md-5 px-xl-3 mt-3 mt-md-1 pt-0 pt-md-2 pt-xl-3 mb-0 pb-0">
            <canvas ngChartjs [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
              [legend]="lineChartLegend" [chartType]="lineChartType" [inlinePlugins]="inlinePlugin" real-time>
            </canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="components row my-0 py-0">
      <div class="col-12">
        <!--table for displaying comprehensive state of business-->
        <div class="container mt-1 mb-2 mx-0 shadow-lg">
          <div class="row">
            <div class="col-12">
              <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
                Comprehensive Report
              </h4>
            </div>
          </div>
        </div>
        <div class="big-card-5 card shadow-lg px-1 mb-3 pb-3">
          <div class="big-card-body-5 card-body pt-xl-2 mx-0 px-0 px-xl-1 mb-0 pb-0">
            <div class="col-12 pt-2 pb-1 mb-0">
              <div class="iteration-2">
                <div class="item-container my-1">
                  <div class="list-card-3 card mt-1 py-2 mb-0 mx-auto px-0 shadow-lg">
                    <div class="list-card-body card-body my-0 py-0 py-md-2 mx-0">
                      <div class="row my-0 py-0">
                        <div class="col-12">
                          <div class="row">
                            <div class="field col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Active Boda Clients:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{ comprehensive.activeBodaClient }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-1 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Active MicroLoan Clients:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{ comprehensive.activeMicroloanClients }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-2 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 d-flex justify-content-start">
                                  <span class="">Active Taxi Clients:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{ comprehensive.activeTaxiClients }}
                                    <span class="itemCreated"> </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-3 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 d-flex justify-content-start">
                                  <span class="">Active Savings Clients:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{ comprehensive.activeSavingsClients }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-4 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 d-flex justify-content-start">
                                  <span class="">All Active Clients:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{ comprehensive.allactiveClients }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-5 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 d-flex justify-content-start">
                                  <span class="">Service Points:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{ comprehensive.servicePoints }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Boda And Taxi Loans Less 24 Hours:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.bodaAndTaxiloansLess24Hours
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-1 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Boda And Taxi Loans In Default 2 To 6
                                    Days:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.bodaAndTaxiLoansInDefault2To6Days
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-2 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Boda And Taxi Loans Recovery 7 To 9
                                    Days:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.bodaAndTaxiLoansRecovery7To9Days
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-3 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Boda And Taxi Loans In Recovery 9 Days
                                    Above:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.bodaAndTaxiLoansInRecovery9DaysAbove
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-4 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Bodaboda Loan Total Portfolio:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.bodabodaLoanTotalPortfolio
                                    | number
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-5 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Bodaboda Loan Total Interest
                                    Expected:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.odabodaLoanTotalInterestExpected
                                    | number
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Taxi Loan Total Portfolio:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.taxiLoanTotalPortfolio
                                    | number
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-1 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Taxi Loan Total Interest Expected:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.taxiLoanTotalInterestExpected
                                    | number
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-2 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Micro Loan Total Portfolio:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.microloanTotalPortfolio
                                    | number
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-3 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Micro Loan Total Interest Expected:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.microloanTotalInterestExpected
                                    | number
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-4 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">OverAll Total Portfolio:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.overAllTotalPortfolio
                                    | number
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-5 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">OverAll Total Interest Expected:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.overAllTotalInterestExpected
                                    | number
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Total Loan And Interest Outstanding:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.totalLoanAndInterestOutstanding
                                    | number
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-1 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Total Revenue:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{ comprehensive.totalRevenue | number }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-2 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Revenue Lost:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{ comprehensive.RevenueLost | number }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-3 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Revenue This Month:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.RevenueThisMonth | number
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-4 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Savings Deposit This Month:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{
                                    comprehensive.SavingsDepositThisMonth
                                    | number
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="field-5 col-12 col-md-6 col-xl-4">
                              <div class="list-item row">
                                <div class="col-6 col d-flex justify-content-start">
                                  <span class="">Total Savings:</span>
                                </div>
                                <div class="col-6 d-flex justify-content-start font-weight-bold">
                                  <span class="itemCreated">
                                    {{ comprehensive.TotalSavings | number }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="components row mt-3 mt-md-2 pt-0">
          <div class="col-12 col-xl-6">
            <div class="container mt-xl-0 mb-2 mx-0 shadow-lg">
              <div class="row">
                <div class="col-12">
                  <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
                    Top Borrowing Clients
                  </h4>
                </div>
              </div>
            </div>
            <div class="big-card-3 card shadow-lg mb-3 py-0">
              <div class="big-card-body-3 card-body mt-0 mt-xl-2 pt-xl-1 px-2 mb-3 pb-0">
                <div class="invest-card card-body mt-0 pt-2 mb-5 mx-auto pb-4 px-1 px-lg-auto shadow-lg">
                  <div class="iteration pb-1">
                    <div class="item-container mt-1 mb-0 py-0 px-3" *ngFor="let user of topBorrowingClients; let i = index">
                      <div class="list-card card mt-1 pt-2 mb-0 mx-1 px-0 pb-1 shadow-lg">
                        <div class="list-card-body card-body my-0 py-0 mx-1 px-0">
                          <div class="row my-0 py-0">
                            <div class="col-1">
                              {{ i + 1 }}
                            </div>
                            <div class="col-11">
                              <div class="row">
                                <div class="col-12 col-md-6 col-xl-7">
                                  <div class="row">
                                    <div class="col-3 col-md-2 col-xl-3 d-flex justify-content-start">
                                      <span class="">Client:</span>
                                    </div>
                                    <div
                                      class="col-9 col-md-10 col-xl-9 d-flex justify-content-start font-weight-bold mx-lg-0 px-lg-0">
                                      <span class="itemCreated">
                                        {{ user.customerName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-5">
                                  <div class="row">
                                    <div class="col-3 col-md-4 d-flex justify-content-start">
                                      <span class="">Phone:</span>
                                    </div>
                                    <div
                                      class="col-9 col-md-8 d-flex justify-content-start font-weight-bold mx-lg-0 px-lg-0">
                                      <span class="itemCreated">
                                        {{ user.customerPhone1 }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-7">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Amount:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold">
                                      <span class="itemCreated">
                                        {{ user.loanAmountBorrowed | number }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-5">
                                  <div class="row">
                                    <div class="col-6 col-sm-4 col-md-5 col-xl-8 d-flex justify-content-start">
                                      <span class="">Times Borrowed:</span>
                                    </div>
                                    <div
                                      class="col-6 col-sm-8 col-md-7 col-xl-4 d-flex justify-content-start font-weight-bold mx-xl-0 px-xl-0">
                                      <span class="itemCreated">
                                        {{ user.numberBorrowed }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-9">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Station:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold">
                                      <span class="itemCreated">
                                        {{ user.stationName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6">
            <div class="container mt-1 mb-2 mx-0 shadow-lg">
              <div class="row">
                <div class="col-12">
                  <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
                    Top Taxi Clients
                  </h4>
                </div>
              </div>
            </div>
            <div class="big-card-3 card shadow-lg mb-3 py-0">
              <div class="big-card-body-3 card-body mt-0 mt-xl-2 pt-xl-1 px-2 mb-3 pb-0">
                <div class="invest-card card-body mt-0 pt-2 mb-5 mx-auto pb-4 px-1 px-lg-auto shadow-lg">
                  <div class="iteration pb-1">
                    <div class="item-container mt-1 mb-0 py-0 px-3" *ngFor="let user of topTaxiClients; let i = index">
                      <div class="list-card card mt-1 pt-2 mb-0 mx-1 px-0 pb-1 shadow-lg">
                        <div class="list-card-body card-body my-0 py-0 mx-1 px-0">
                          <div class="row my-0 py-0">
                            <div class="col-1">
                              {{ i + 1 }}
                            </div>
                            <div class="col-11">
                              <div class="row">
                                <div class="col-12 col-md-6 col-xl-7">
                                  <div class="row">
                                    <div class="col-3 col-md-2 col-xl-3 d-flex justify-content-start">
                                      <span class="">Client:</span>
                                    </div>
                                    <div
                                      class="col-9 col-md-10 col-xl-9 d-flex justify-content-start font-weight-bold mx-lg-0 px-lg-0">
                                      <span class="itemCreated">
                                        {{ user.customerName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-5">
                                  <div class="row">
                                    <div class="col-3 col-md-4 d-flex justify-content-start">
                                      <span class="">Phone:</span>
                                    </div>
                                    <div
                                      class="col-9 col-md-8 d-flex justify-content-start font-weight-bold mx-lg-0 px-lg-0">
                                      <span class="itemCreated">
                                        {{ user.customerPhone1 }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-7">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Amount:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold">
                                      <span class="itemCreated">
                                        {{ user.loanAmountBorrowed | number }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-5">
                                  <div class="row">
                                    <div class="col-6 col-sm-4 col-md-5 col-xl-8 d-flex justify-content-start">
                                      <span class="">Times Borrowed:</span>
                                    </div>
                                    <div
                                      class="col-6 col-sm-8 col-md-7 col-xl-4 d-flex justify-content-start font-weight-bold mx-xl-0 px-xl-0">
                                      <span class="itemCreated">
                                        {{ user.numberBorrowed }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-9">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Station:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold">
                                      <span class="itemCreated">
                                        {{ user.stationName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6">
            <div class="container mt-1 mb-2 mx-0 shadow-lg">
              <div class="row">
                <div class="col-12">
                  <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
                    Top Bodaboda clients
                  </h4>
                </div>
              </div>
            </div>
            <div class="big-card-3 card shadow-lg mb-3 py-0">
              <div class="big-card-body-3 card-body mt-0 mt-xl-2 pt-xl-1 px-2 mb-3 pb-0">
                <div class="invest-card card-body mt-0 pt-2 mb-5 mx-auto pb-4 px-1 px-lg-auto shadow-lg">
                  <div class="iteration pb-1">
                    <div class="item-container mt-1 mb-0 py-0 px-3" *ngFor="let user of topBodaBodaClients; let i = index">
                      <div class="list-card card mt-1 pt-2 mb-0 mx-1 px-0 pb-1 shadow-lg">
                        <div class="list-card-body card-body my-0 py-0 mx-1 px-0">
                          <div class="row my-0 py-0">
                            <div class="col-1">
                              {{ i + 1 }}
                            </div>
                            <div class="col-11">
                              <div class="row">
                                <div class="col-12 col-md-6 col-xl-7">
                                  <div class="row">
                                    <div class="col-3 col-md-2 col-xl-3 d-flex justify-content-start">
                                      <span class="">Client:</span>
                                    </div>
                                    <div
                                      class="col-9 col-md-10 col-xl-9 d-flex justify-content-start font-weight-bold mx-lg-0 px-lg-0">
                                      <span class="itemCreated">
                                        {{ user.customerName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-5">
                                  <div class="row">
                                    <div class="col-3 col-md-4 d-flex justify-content-start">
                                      <span class="">Phone:</span>
                                    </div>
                                    <div
                                      class="col-9 col-md-8 d-flex justify-content-start font-weight-bold mx-lg-0 px-lg-0">
                                      <span class="itemCreated">
                                        {{ user.customerPhone1 }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-7">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Amount:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold">
                                      <span class="itemCreated">
                                        {{ user.loanAmountBorrowed | number }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-5">
                                  <div class="row">
                                    <div class="col-6 col-sm-4 col-md-5 col-xl-8 d-flex justify-content-start">
                                      <span class="">Times Borrowed:</span>
                                    </div>
                                    <div
                                      class="col-6 col-sm-8 col-md-7 col-xl-4 d-flex justify-content-start font-weight-bold mx-xl-0 px-xl-0">
                                      <span class="itemCreated">
                                        {{ user.numberBorrowed }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-9">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Station:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold">
                                      <span class="itemCreated">
                                        {{ user.stationName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6">
            <div class="container mt-1 mb-2 mx-0 shadow-lg">
              <div class="row">
                <div class="col-12">
                  <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
                    Top Microloan clients
                  </h4>
                </div>
              </div>
            </div>
            <div class="big-card-3 card shadow-lg mb-3 py-0">
              <div class="big-card-body-3 card-body mt-0 mt-xl-2 pt-xl-1 px-2 mb-3 pb-0">
                <div class="invest-card card-body mt-0 pt-2 mb-5 mx-auto pb-4 px-1 px-lg-auto shadow-lg">
                  <div class="iteration pb-1">
                    <div class="item-container mt-1 mb-0 py-0 px-3" *ngFor="let user of topMircroloanClients; let i = index">
                      <div class="list-card card mt-1 pt-2 mb-0 mx-1 px-0 pb-1 shadow-lg">
                        <div class="list-card-body card-body my-0 py-0 mx-1 px-0">
                          <div class="row my-0 py-0">
                            <div class="col-1">
                              {{ i + 1 }}
                            </div>
                            <div class="col-11">
                              <div class="row">
                                <div class="col-12 col-md-6 col-xl-7">
                                  <div class="row">
                                    <div class="col-3 col-md-2 col-xl-3 d-flex justify-content-start">
                                      <span class="">Client:</span>
                                    </div>
                                    <div
                                      class="col-9 col-md-10 col-xl-9 d-flex justify-content-start font-weight-bold mx-lg-0 px-lg-0">
                                      <span class="itemCreated">
                                        {{ user.customerName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-5">
                                  <div class="row">
                                    <div class="col-3 col-md-4 d-flex justify-content-start">
                                      <span class="">Phone:</span>
                                    </div>
                                    <div
                                      class="col-9 col-md-8 d-flex justify-content-start font-weight-bold mx-lg-0 px-lg-0">
                                      <span class="itemCreated">
                                        {{ user.customerPhone1 }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-7">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Amount:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold">
                                      <span class="itemCreated">
                                        {{ user.loanAmountBorrowed | number }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-5">
                                  <div class="row">
                                    <div class="col-6 col-sm-4 col-md-5 col-xl-8 d-flex justify-content-start">
                                      <span class="">Times Borrowed:</span>
                                    </div>
                                    <div
                                      class="col-6 col-sm-8 col-md-7 col-xl-4 d-flex justify-content-start font-weight-bold mx-xl-0 px-xl-0">
                                      <span class="itemCreated">
                                        {{ user.numberBorrowed }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-xl-9">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Station:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold">
                                      <span class="itemCreated">
                                        {{ user.stationName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6">
            <div class="container mt-1 mb-2 mx-0 shadow-lg">
              <div class="row">
                <div class="col-12">
                  <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
                    Top Savings clients
                  </h4>
                </div>
              </div>
            </div>
            <div class="big-card-3 card shadow-lg mb-3 py-0">
              <div class="big-card-body-3 card-body mt-0 mt-xl-2 pt-xl-1 px-2 mb-3 pb-0">
                <div class="invest-card card-body mt-0 pt-2 mb-5 mx-auto pb-4 px-1 px-lg-auto shadow-lg">
                  <div class="iteration pb-1">
                    <div class="item-container mt-1 mb-0 py-0 px-3" *ngFor="let user of topSavingsClients; let i = index">
                      <div class="list-card card mt-1 pt-2 mb-0 mx-1 px-0 pb-1 shadow-lg">
                        <div class="list-card-body card-body my-0 py-0 mx-1 px-0">
                          <div class="row my-0 py-0">
                            <div class="col-1">
                              {{ i + 1 }}
                            </div>
                            <div class="col-11">
                              <div class="row">
                                <div class="col-12 col-md-6">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Client:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold mx-lg-0 px-lg-0">
                                      <span class="itemCreated">
                                        {{ user.customerName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Phone:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold mx-lg-0 px-lg-0">
                                      <span class="itemCreated">
                                        {{ user.customerPhone1 }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Balance:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold">
                                      <span class="itemCreated">
                                        {{ user.savingsBalance | number }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6">
                                  <div class="row">
                                    <div class="col-3 d-flex justify-content-start">
                                      <span class="">Station:</span>
                                    </div>
                                    <div class="col-9 d-flex justify-content-start font-weight-bold mx-xl-0 px-xl-0">
                                      <span class="itemCreated">
                                        {{ user.stationName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
